/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Comment_Field_PlaceholderInputs */

const en_comment_field_placeholder = /** @type {(inputs: Comment_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave a note for the service desk…`)
};

const ja_comment_field_placeholder = /** @type {(inputs: Comment_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスデスクへのメモを入力してください…`)
};

const fr_comment_field_placeholder = /** @type {(inputs: Comment_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez une note pour le service desk…`)
};

const de_comment_field_placeholder = /** @type {(inputs: Comment_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinterlassen Sie eine Notiz für den Service Desk…`)
};

/**
* | output |
* | --- |
* | "Leave a note for the service desk…" |
*
* @param {Comment_Field_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const comment_field_placeholder = /** @type {((inputs?: Comment_Field_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Comment_Field_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_comment_field_placeholder(inputs)
	if (locale === "ja") return ja_comment_field_placeholder(inputs)
	if (locale === "fr") return fr_comment_field_placeholder(inputs)
	return de_comment_field_placeholder(inputs)
});